const initialState = {
  signUpValue: 0,
  loginState: true,
};

const signUpReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SIGN_UP":
      return { ...state, signUpValue: action.payload };
    case "SET_LOGIN_STATE":
      return { ...state, loginState: action.payload };
    default:
      return state;
  }
};

export default signUpReducer;
